import SuccessModal from '../../components/modales/SuccessModal.jsx';
import ErrorModal from '../../components/modales/ErrorModal.jsx';
import { useForgotPassword } from '../../hooks/auth/useForgotPassword.js';

export default function ForgotPassword() {
    const {
        email,
        setEmail,
        loading,
        handleSubmit,
        showErrorModal,
        errorMessage,
        closeErrorModal,
        showSuccessModal,
        successMessage,
        closeSuccessModal
    } = useForgotPassword();

    return (
        <>
            <div className="container mt-5">
                <div className="text-center col-12 col-sm-8 col-md-6 col-lg-4 m-auto border rounded-3 p-4">
                    <h1 className="mb-4"><i className="bi bi-lock-fill"></i></h1>
                    <h2 className="text-center">¿Olvidaste tu contraseña?</h2>
                    <p className="mb-4">Puedes restablecer tu contraseña aquí.</p>
                    <form onSubmit={handleSubmit}>
                        <div className="input-group mb-3">
                            <span className="input-group-text" id="basic-addon1"><i className="bi bi-envelope-fill"></i></span>
                            <input className="form-control" type="email" value={email} placeholder="email" aria-label="email" aria-describedby="basic-addon1" onChange={(e) => setEmail(e.target.value)} required />
                        </div>
                        <div className="form-group">                                                
                            <button className="btn btn-md btn-primary" type="submit" disabled={loading}>{loading ? 'Enviando...' : 'Enviar correo'}</button>
                        </div>
                    </form>
                </div>
            </div>
            <SuccessModal
                show={showSuccessModal}
                message={successMessage}
                onClose={closeSuccessModal}
            />
            <ErrorModal
                show={showErrorModal}
                message={errorMessage}
                onClose={closeErrorModal}
            />
        </>
    );
}